import React from 'react';
import styled from 'styled-components';
import CompareMoviesGif from '../../images/compare-movies-demo.gif';
import DemoInsideMac from '../../components/DemoInsideMac';
import Button from '../../components/Button';
import Helmet from '../../components/Helmet';
import H1 from '../../components/H1';
import P from '../../components/P';
import Icon from '../../components/Icon';
import Contact from '../../components/Contact';
import NavigationLinks from '../../components/NavigationLinks';
import CompareMoviesImage from '../../images/compare-movies.jpg';

const CompareMovies = styled.article`
  margin: auto;
  max-width: 700px;
  padding: 0 10px;

  p {
    margin-bottom: 25px;
  }
`;

const Header = styled.header`
  text-align: center;
`;

const GithubIcon = styled.span`
  margin-right: 10px;
`;

const Buttons = styled.div`
  margin: 25px 0;

  a {
    margin: 10px;
    width: 120px;
  }
`;

export default () => (
  <main>
    <Helmet
      title="Gowtham Selvaraj (Gauti) Project - Compare Movies - Compare Movies and TV Shows Instantly"
      description="Compare Movies is a web app which compares movies and TV shows
    instantly. You can compare ratings from various sources (IMDB, Rotten
    Tomatoes, Metacritic and TMDB), awards info, DVD release dates, casts,
    crews, and so on. You can also watch trailers, videos, posters and other
    images all in one place."
      image={CompareMoviesImage}
      path="/projects/compare-movies"
    />
    <CompareMovies>
      <Header>
        <H1>Compare Movies</H1>
        <P bigger>Compare Movies and TV Shows Instantly</P>

        <Buttons>
          <Button
            link
            bordered
            small
            href="https://www.comparemovies.info"
            title="Visit comparemovies.info"
            target="_blank"
            rel="noopener"
          >
            Visit Project
          </Button>

          <Button
            link
            bordered
            small
            href="https://github.com/gautiselvaraj/compare-movies"
            title="Visit Compare Movies Github Repo"
            target="_blank"
            rel="noopener"
          >
            <GithubIcon>
              <Icon github />
            </GithubIcon>
            Github
          </Button>
        </Buttons>
      </Header>

      <DemoInsideMac
        src={CompareMoviesGif}
        alt="Compare Movies and TV Shows Instantly"
      />
      <P big>
        Compare Movies is a web app which compares movies and TV shows
        instantly. You can compare ratings from various sources (IMDB, Rotten
        Tomatoes, Metacritic and TMDB), awards info, DVD release dates, casts,
        crews, and so on. You can also watch trailers, videos, posters and other
        images all in one place.
      </P>
      <P big>
        I used React, Redux, Immutable.js and Next.js for compare movies.
        Next.js helps in server-side rendering of React applications. I wrote
        search/autocomplete, modal and image gallery components explicitly for
        compare movies. I utilized both TMDB and OMDB API to fetch movie and TV
        shows information. Finally, I used Google Cloud Platform's App Engine to
        host the app.
      </P>

      <Contact />
    </CompareMovies>

    <NavigationLinks
      prevLink="/projects/react-shorten/"
      prevCopy="React Shorten"
      nextLink="/projects/nag-me/"
      nextCopy="Nag Me"
    />
  </main>
);



// WEBPACK FOOTER //
// ./src/pages/projects/compare-movies.js